// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ALa9G2syl0S2tY {\n  font-size: 14px;\n  line-height: 20px;\n}\n._1O70sY4FlOzlIc {\n  text-decoration: underline;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messaging": "ALa9G2syl0S2tY",
	"ctaLink": "_1O70sY4FlOzlIc"
};
export default ___CSS_LOADER_EXPORT___;
